import Overview from './overview';
import CompanyOverview from './company-overview';
import Followers from './followers';
import DataDeletionRequests from './data-deletion-requests';
import EmailMessages from './email-messages';
import EmailTemplate from './email-template';
import GoogleBusiness from './google-business';
import GoogleReviewProgram from './google-review-program';
import LoyaltyProgram from './loyalty-program';
import PromoCodes from './promo-codes';
import GoogleAds from './google-ads';
import FeaturedPosts from './featured-posts';
import Offers from './offers';
import Polygraphy from './polygraphy';
import TrackingLinks from './tracking-links';
import PushNotifications from './push-notifications';

export default {
  Overview,
  CompanyOverview,
  Followers,
  DataDeletionRequests,
  EmailMessages,
  EmailTemplate,
  GoogleBusiness,
  GoogleReviewProgram,
  LoyaltyProgram,
  PromoCodes,
  TrackingLinks,
  GoogleAds,
  FeaturedPosts,
  Offers,
  Polygraphy,
  PushNotifications,
};
